import cn from "../../../lib/cn";
import Counter from "../../animation/typography/Counter";
import Container from "../../Container";
import H4 from "../../typography/H4";
import P from "../../typography/P";

const SalesSummaryCard = ({
    name,
    salesData,
    isActive,
    className,
    totalSales,
}) => {
    return (
        <Container
            className={cn(
                `${isActive && "bg-blue-550  rounded-2xl "} py-1 px-1`,
                className
            )}
        >
            <div className="flex flex-col w-full">
                <div
                    className={`${
                        isActive && "text-white"
                    } flex gap-4  items-center justify-between  w-full  p-0.5 mb-1`}
                >
                    <H4
                        className={
                            "text-nowrap text-xs xs:text-sm md:text-xs xl:text-xs text-white"
                        }
                    >
                        {name}
                    </H4>
                    {totalSales && (
                        <P className="bg-white text-center px-1 text-xs xs:text-xs sm:text-xs  xl:text-xs py-0.5 text-nowrap rounded-3xl ">
                            Total Sales {totalSales}
                        </P>
                    )}
                </div>
                <div className="flex flex-wrap  justify-between w-full gap-1  ">
                    {salesData.map((data, index) => (
                        <>
                            <div key={index} className="text-center sm:px-1 ">
                                <H4 className="text-white md:text-base xl:text-base">
                                    <Counter value={data.value} />
                                </H4>
                                <P className="text-sm sm:text-xs xl:text-xs text-white text-nowrap">
                                    {data.label}
                                </P>
                            </div>
                            {index !== salesData.length - 1 && (
                                <div
                                    className={` min-h-[1em]  w-0.1 self-stretch bg-gray-100 ${
                                        index === salesData.length / 2 - 1 &&
                                        "flex lg:hidden xl:flex"
                                    }`}
                                ></div>
                            )}
                        </>
                    ))}
                </div>
            </div>
        </Container>
    );
};

export default SalesSummaryCard;
